<template>
    <div class="lpContainer">
        <div class="links d-flex mt-2 mb-5">
            <a href="https://yokumiru.jp/privacy-policy" target="_blank">プライバシーポリシー</a>
            <div class="text-muted small pt-1">&nbsp;&nbsp;/&nbsp;&nbsp;</div>
            <a href="https://yokumiru.jp/terms" target="_blank">利用規約</a>
        </div>

        <section class="section">
            <h3 class="sectionHeading">YOKUMIRU&nbsp;/&nbsp;Googleカレンダー連携</h3>
            <p>YOKUMIRUの相談スケジュールとGoogleカレンダーが連携可能になりました。</p>
            <p>連携すると、相談予約が行われた際に相談予定がGoogleカレンダーへ自動登録されます。逆に、Googleカレンダーで登録した個人的な予定（相談できない時間帯）は休診としてYOKUMIRUに自動登録されます。</p>
        </section>

        <section class="section">
            <h3 class="sectionHeading">設定方法</h3>
            <section class="sectionInner">
                <h4>1.&nbsp;YOKUMIRUにログイン</h4>
                <p><a href="/doctor/login">ログイン</a>後、メニューから「相談スケジュール」画面へ進みます。</p>
                <img src="/images/doctors/google_calendar_lp_00.png">
            </section>
            <section class="sectionInner">
                <h4>2.&nbsp;Googleアカウントを認証する</h4>
                <p>「Googleカレンダーと連携」ボタンを押して、Googleアカウントの認証を行います。</p>
                <img src="/images/doctors/google_calendar_lp_01.png">
                <img src="/images/doctors/google_calendar_lp_02.png">
            </section>
            <section class="sectionInner">
                <h4>3.&nbsp;連携するカレンダーを選択する</h4>
                <p>YOKUMIRUと連携したいカレンダーを選択して保存すると、Googleカレンダーで登録した個人的な予定（相談できない時間帯）が休診としてYOKUMIRUに自動登録されるようになります。</p>
                <img src="/images/doctors/google_calendar_lp_03_2.png">
                <img src="/images/doctors/google_calendar_lp_03.png">
                <p class="mt-2">また、相談予約が行われた場合は相談予定がGoogleカレンダーへ自動登録されます。</p>
                <img src="/images/doctors/google_calendar_lp_04.png">
            </section>
        </section>

        <div class="lpEndContent">
            <div class="d-flex justify-content-center">
                <b-button
                    href="/doctor/login"
                    class="btn btn-yokumiru-doctor">
                    YOKUMIRUにログインして設定を行う
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {}
        },
    }
</script>

<style lang="scss">
.lpContainer {
    width: 720px;
    margin: 0 auto;

    img {
        width: 100%;
        margin-bottom: 10px;
        border: 1px solid #ced0d1;
    }
}

.section {
    margin-bottom: 40px;

    a {
        text-decoration: underline;
    }

    .sectionInner {
        margin-bottom: 25px;
    }
}

.sectionHeading {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #DA5872;
}

.lpEndContent {
    margin-bottom: 120px;
}

.links {
    font-size: 16px;

    a {
        text-decoration: underline;
    }
}
</style>
